import { useMemo, useState } from 'preact/hooks'

/**
 *
 * @param {any[]} data
 * @returns {[[]]}
 */
const handlePageSplitData = (data, limit) => {
  return data.reduce((acc, d, i) => {
    if (i % limit === 0) {
      acc.push([d])
      return acc
    }
    const len = acc.length - 1

    acc[len].push(d)
    return acc
  }, [])
}

/**
 *
 * @param {{data: any[], limit: number}} param0
 * @returns {{config: {limit: number, pageData: [[]], pageMin: number, pageMax: number}, page: any[], handleNextPage: (action : 'previous' | 'next') => number, index: number}}
 */
export const usePaginate = ({ data, limit }) => {
  const [index, setIndex] = useState(0)

  const config = useMemo(() => {
    const pageLimit = limit ?? 5
    const pageData = handlePageSplitData(data, pageLimit)
    const pageMin = 0
    const pageMax = pageData.length - 1

    return {
      limit: pageLimit,
      pageData,
      pageMin,
      pageMax
    }
  }, [data])

  /**
   * @returns {[]any}
   */
  const page = useMemo(() => {
    return config.pageData[index]
  }, [index, data])

  /**
   *
   * @param {'previous' | 'next'} action
   * @returns {number}
   */
  const handleNextPage = (action) => {
    setIndex((currentIndex) => {
      if (action === 'next') {
        const nextIndex = currentIndex + 1 >= config.pageMax ? config.pageMax : currentIndex + 1
        return nextIndex
      }

      const nextIndex = currentIndex - 1 <= config.pageMax ? config.pageMin : currentIndex - 1
      return nextIndex
    })
  }

  return { config, page, handleNextPage, index }
}
